// components/Navbar/Navbar.jsx
import React from "react";
import { Home, Briefcase, Users, Mail, Menu, X, Rocket } from "lucide-react";
import "./Navbar.css";
import { useLocation, Link } from "react-router-dom";
import KatroriLogo from "../../assets/images/katroriLogoBG.png";

const Navbar = ({ setCurrentSection, isMenuOpen, toggleMenu }) => {
  const location = useLocation();
  const isProductPage = location.pathname.includes("/product");

  const navItems = [
    { name: "Home", icon: Home, section: "home" },
    { name: "Services", icon: Rocket, section: "services" },
    { name: "Products", icon: Briefcase, section: "products" },
    { name: "About Us", icon: Users, section: "about" },
    { name: "Contact", icon: Mail, section: "contact" },
  ];

  const filteredNavItems = isProductPage
    ? navItems.filter((item) => item.section === "home")
    : navItems;

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <a href="/#home">
          <img src={KatroriLogo} alt="Katrori Logo" />
        </a>

        <div className="navbar-links-desktop">
          {filteredNavItems.map((item) =>
            isProductPage ? (
              <Link
                key={item.name}
                to="/"
                className="nav-link font-body"
                style={{ textDecoration: "none" }}
              >
                {item.name}
              </Link>
            ) : (
              <a
                key={item.name}
                href={`#${item.section}`}
                onClick={() => setCurrentSection(item.section)}
                className="nav-link font-body"
                style={{ textDecoration: "none" }}
              >
                {item.name}
              </a>
            )
          )}
        </div>

        <div className="navbar-toggle">
          {isProductPage ? (
            <Link
              to="/home"
              className="navbar-toggle-button"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <Home className="icon-large" />
            </Link>
          ) : (
            <button onClick={toggleMenu} className="navbar-toggle-button">
              {isMenuOpen ? (
                <X className="icon-large" />
              ) : (
                <Menu className="icon-large" />
              )}
            </button>
          )}
        </div>
      </div>

      {isMenuOpen && !isProductPage && (
        <div className="navbar-links-mobile">
          <div className="navbar-links-mobile-inner">
            {filteredNavItems.map((item) => (
              <a
                key={item.name}
                href={`#${item.section}`}
                onClick={() => {
                  setCurrentSection(item.section);
                  toggleMenu();
                }}
                className="nav-link-mobile font-body"
              >
                <item.icon className="icon-medium icon-margin-right" />
                {item.name}
              </a>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
